<template>
  <div class="be-content" v-if="operator">
    <div class="main-content container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default panel-border-color panel-border-color-primary">
            <div class="panel-heading panel-heading-divider">Редактирование оператора курортного сбора - <b>Рег.№{{operator.id}}</b>
            </div>
            <div class="panel-body">
              <operator-form :operator="operator" ref="form" @dataIsValid="submitData"></operator-form>
              <div class="row xs-pt-15">
                <div class="col-xs-12">
                  <p class="text-center">
                    <button class="btn btn-space btn-success btn-lg " @click="validateDataForm">Сохранить изменения
                    </button>
                    <router-link :to="{name: 'operators'}">
                      <button class="btn btn-space btn-danger btn-lg">Отмена
                      </button>
                    </router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import OperatorForm from './OperatorForm'
  import {mapActions} from 'vuex'

  export default {
    components: {OperatorForm},
    props: {
      id: {
        required: true
      }
    },
    data: function () {
      return {
        operator: null
      }
    },
    created () {
      axios.get('/api/operators/' + this.id + '/')
        .then(response => {
          this.operator = response.data
        })
    },
    methods: {
      submitData: function () {
        if (this.operator.legal_entity_form) {
          this.operator.legal_entity_form = this.operator.legal_entity_form['id']
        }
        this.operator.region = this.operator.region['id']
        this.operator.type = this.operator.type['id']
        let self = this
        axios.patch('/api/operators/' + this.id + '/', this.operator)
          .then((response) => {
            if (response.status === 200) {
              this.getOperators()
              this.$router.push({name: 'operators'})
              this.$snotify.success('Изменения сохранены.', 'Успешно!')
            }
          })
          .catch((error) => {
            if (error.response.status >= 400) {
              this.$snotify.error('Ошибка сохранения данных!')
              this.$refs.form.updateFieldValue()
            }
          })
      },
      validateDataForm: function () {
        this.$refs.form.validate()
      },
      ...mapActions([
        'getOperators',
      ])
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/operators/OperatorEdit.vue